// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ChevronRight48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ChevronRight48: FC<ChevronRight48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="m20.686 38.4-2.972-2.416L27.52 24l-9.806-11.983L20.686 9.6 32.48 24 20.686 38.4Z" />
        </svg>
    );
};

export default ChevronRight48;
